module.exports = __webpack_public_path__ + "img/repositorio-link.e151cbc0.png";